﻿<script>
	import { registerPageComplete } from "../../tealium";
    import model from "../../stores/modelStore";
	import textStore from "../../stores/textStore";
    import { projectSettings, acceptedFileUploadList } from "../../config";
    import { isValid } from "../../validation";

    import PageSection from "../../components/PageSection.svelte";
    import Form from "../../components/Form.svelte";
    import FormRow from "../../components/FormRow.svelte";
    import FormColumn from "../../components/FormColumn.svelte";
    import YesNoGroup from "../../components/YesNoGroup.svelte";
    import TextInput from "../../components/TextInput.svelte";
    import TextArea from "../../components/TextArea.svelte";
    import RadioGroup from "../../components/RadioGroup.svelte";
    import RadioGroupWithImage from "../../components/RadioGroupWithImage.svelte";
    import MonthYearSelect from "../../components/MonthYearSelect.svelte";
    import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
    import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
    import NavigationButtons from "../../components/NavigationButtons.svelte";
    import Deceased from "../../components/Deceased.svelte";
    import FileUpload from "../../components/FileUpload.svelte";
    import EmploymentPlaces from "../../components/EmploymentPlaces.svelte";
    import Select from "../../components/Select.svelte";

    export let pageName = null;
    export let pageTitle = null;
    export let lastVisitedPage = null;
	export let persistUrl = null;
    export let disabled = null;
    export let required = null;
    
	let buttons;

    if (!disabled) {
        $model.lastPageVisited = lastVisitedPage;
        document.title = pageTitle;
    }

    const handleSubmit = async () => {
		buttons.blockNext();
        
        // clean up
        cleanSelections();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(response);
			} else {
				registerPageComplete(
					pageName,
					$model.contact.emailAddress,
					$model.contact.phoneNumber,
				);
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const cleanSelections = () => {
	};
</script>


<PageSection>
	<Form id="form-additionalInfo-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Additional Information</h1>
			</FormColumn>
		</FormRow>
        	

		<div class="confirmation-box-shadow">
            <FormRow>
                <FormColumn>
                    <YesNoGroup
                        {disabled}
					    {required}
					    name="hasAdditionalInfo"
					    label="Is there anything else you'd like to tell us?"
                        sublabel="You do not need to complete this part, but you can use this part to tell us any further information."
					    bind:value={$model.hasAdditionalInfo}
                    />
                </FormColumn>
            </FormRow>

            {#if $model.hasAdditionalInfo === "Yes"}
                <FormRow>
                    <FormColumn>
                        <h3>Additional Details</h3>
                         <TextArea
                            required={false}
                            {disabled}
                            id="additionalInfo"
                            lllabel="Is there anything else you'd like to tell us?"
                            bind:value={$model.additionalInfo} />
                    </FormColumn>
                </FormRow>
            {/if}
		</div>

        <FormRow class="confirmation-hide">
			<FormColumn>
				<NavigationButtons bind:buttons
					nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
    h1 {
        margin-bottom: 20px;
    }
</style>